(function() {
  addEventListener("trix-attachment-add", function(event) {
    if (event.attachment.file) {
      uploadFileAttachment(event.attachment, event.target.dataset.attachmentsUrl)
    }
  })

  addEventListener("trix-attachment-remove", function(event) {
    const url = event.target.dataset.attachmentsUrl + '/' + event.attachment.getAttributes().id;
    const xhr = new XMLHttpRequest()

    xhr.open("DELETE", url, true)
    xhr.setRequestHeader('X-CSRF-Token', window.POC.csrfToken())
    xhr.send()
  })

  function uploadFileAttachment(attachment, url) {
    uploadFile(attachment.file, url, setProgress, setAttributes)

    function setProgress(progress) {
      attachment.setUploadProgress(progress)
    }

    function setAttributes(attributes) {
      attachment.setAttributes(attributes)
    }
  }

  function uploadFile(file, url, progressCallback, successCallback) {
    const formData = new FormData()
    formData.append("attachment[data]", file)
    const xhr = new XMLHttpRequest()

    xhr.open("POST", url, true)
    xhr.setRequestHeader('X-CSRF-Token', window.POC.csrfToken())

    xhr.upload.addEventListener("progress", function(event) {
      const progress = event.loaded / event.total * 100
      progressCallback(progress)
    })

    xhr.addEventListener("load", function(event) {
      if (xhr.status == 201) {
        const response = JSON.parse(event.target.response);
        const attributes = {
          url: response.data.attributes.url,
          id: response.data.id
        }
        successCallback(attributes)
      } else {
        alert('Something went wrong with the upload.')
      }
    })

    xhr.send(formData)
  }
})();